import { Injectable } from '@angular/core';
import { filter, tap } from 'rxjs/operators';
import { DobryPradWelcomeDialogComponent } from '../../offers/components/dobry-prad-welcome-dialog/dobry-prad-welcome-dialog.component';
import { MAX_WIDTH_90, WIDTH_430 } from '../../shared/configs/dialog-config';
import { ModalComponent } from '../components/modal/modal.component';
import { ModalType } from '../models/modal-type.enum';
import { Modal } from '../models/modal.model';
import { CustomerStoreService } from './customer-store.service';
import { DialogService } from './dialog.service';
import { ModalApiService } from './modal-api.service';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  constructor(
    private customerStoreService: CustomerStoreService,
    private modalApiService: ModalApiService,
    private dialogService: DialogService,
  ) {}

  public checkAndShowModal(): void {
    if (this.customerStoreService.isCustomerLocked()) {
      return;
    }

    this.modalApiService
      .getModal()
      .pipe(
        filter((modal) => !!modal.modalType),
        tap((modal: Modal) => {
          this.openModalByType(modal);
        }),
      )
      .subscribe();
  }

  public showCampaignModal(campaignId: string): void {
    this.modalApiService
      .searchForCampaign(campaignId)
      .pipe(
        filter((modal) => !!modal.modalType),
        tap((modal: Modal) => {
          this.openModalByType(modal);
        }),
      )
      .subscribe();
  }

  private openModalByType(modalData: Modal): void {
    const { modalType } = modalData;

    if (modalType === ModalType.TEXT) {
      this.openTextDialog(modalData);
    } else if (modalType === ModalType.DOBRY_PRAD) {
      this.openDobryPradDialog(modalData);
    } else {
      throw new Error('Unsupported modal type');
    }
  }

  private openTextDialog(modalData: Modal): void {
    this.dialogService
      .open(ModalComponent, {
        data: modalData,
        maxWidth: MAX_WIDTH_90,
        width: WIDTH_430,
      })
      .afterClosed()
      .subscribe(() => this.markAsSeen(modalData.modalId));
  }

  private openDobryPradDialog(modalData: Modal): void {
    this.dialogService
      .open(DobryPradWelcomeDialogComponent, {
        data: modalData,
        maxWidth: MAX_WIDTH_90,
        width: WIDTH_430,
      })
      .afterClosed()
      .subscribe(() => this.markAsSeen(modalData.modalId));
  }

  private markAsSeen(modalId: string): void {
    if (modalId) {
      this.modalApiService.deleteModal(modalId).subscribe();
    }
  }
}
